import { render, staticRenderFns } from "./IndexContact.vue?vue&type=template&id=29c24bc3&"
import script from "./IndexContact.vue?vue&type=script&lang=ts&"
export * from "./IndexContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c24bc3')) {
      api.createRecord('29c24bc3', component.options)
    } else {
      api.reload('29c24bc3', component.options)
    }
    module.hot.accept("./IndexContact.vue?vue&type=template&id=29c24bc3&", function () {
      api.rerender('29c24bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/IndexContact.vue"
export default component.exports